import each from 'lodash/each';
import find from 'lodash/find';
import toArray from 'lodash/toArray';
import dateFns from './date-fns';
// import tooltip from 'bootstrap/js/dist/tooltip'; //used as jQuery plugin
import flatpickr from 'flatpickr'; //used as jQuery plugin
import select2 from 'select2'; //used as jQuery plugin

import 'bootstrap/dist/css/bootstrap.min.css';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap4-theme/dist/select2-bootstrap4.min.css';
import 'flatpickr/dist/flatpickr.min.css';

var loc = window.location,
    // formats = {
    //     'yyyy/MM/dd': /^(\d{1,2})([\/.-])(\d{1,2})\2(\d{2,4})/,
    //     'MM/dd/yyyy': /^(\d{2,4})([\/.-])(\d{1,2})\2(\d{1,2})/,
    //     'H:m:s': /(\d{1,2})?([:.])?(\d{1,2})\2?(\d{1,2})(\.(\d{1,3})Z?)?$/,
    // },
    select2Options = {
        theme: 'bootstrap4',
        width: '100%',
        minimumResultsForSearch: 6
    },
    now = new Date(),
    defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
    defaultCountry = getString(defaultTimeZone.split('/')[0], 'America'),
    defaultGmtOffset = dateFns.format(new Date(), 'OOOO').replace(':', ''),
    storageKey = 'cd-storage',
    timeZone,
    parsedDate,
    parsedGmtOffset,
    storage;
    
    try {
            storage = JSON.parse(localStorage.getItem(storageKey));
    }
    catch(exc) {}
    
    if(!storage) storage = {};
    if(!storage.rows) storage.rows = []
    
    timeZone = getString(storage.timezone, defaultTimeZone);
    
// defaultTimeZone = timeZone = 'Europe/Paris';
// defaultCountry = defaultTimeZone.split('/')[0];
// defaultGmtOffset = 'GMT+0100';

function getString(value, defaultValue) {
    if(typeof(value) != 'string') {
        if(value === undefined || value == null) value = defaultValue || '';
        else value += '';
    }
    return value;
}

function replaceAll(value, start, end) {
    return value.split(start).join(end);
}

function formatString(value) {
    if(!value) return '';

    var args = toArray(arguments).slice(1);
    return value.replace(/{(\d+)}/g, function(match, index) {
        return getString(args[index]);
    });
}

function empty(obj) {
    if(obj) {
        if(obj instanceof Array) obj.length = 0;
        else for(var key in obj) delete obj[key];
    }
    return obj;
}

function padLeft(value, size) {
    value = value ? value + '' : '';
    while (value.length < size) value = '0' + value;
    return value;
}

function isValidDate(date) {
    return dateFns.isDate(date) && isFinite(date);
}

function urlParams(value, params) {
    if(!value) value = loc.search;
    if(!params) params = {};
    each(value.split('&'), function(item) {
        item = item.split('=');
        params[$.trim(item[0])] = $.trim(decodeURIComponent(item[1]));
    });
    return params;
}

function urlParamsToSearch(obj) {
    var search = '';
    each(obj, function(value, key) {
        if(value) {
            if(search) search += '&';
            search += key + '=' + encodeURIComponent(value);
        }
    });
    return search;
}

$(function() {
    //console.log(dateFns.parse(''));
    $('#container').css('display', '');
    
    var $input = $('#txt-input').val(getString(storage.date)),
        $timezone = $('#ddl-timezone, [data-role="ddl-timezone"]'),
        timeZoneHtml = '',
        hashedTimezones = {},
        $clonedOutputRow,
        hashedTimezone,
        gmtOffset,
        gmtOffset2;
        
    //for testing
    window.hashedTimezones = hashedTimezones;

    each(dateFns.timezones, function(item) {
        if(item.indexOf('Etc/') == -1/* && item.indexOf('/') >= 0*/) { 
            try {
                gmtOffset = dateFns.format(now, 'OOOO', {
                    timeZone: item
                });
            }
            catch(exc) {
                //console.warn(exc);
                return;
            }

            gmtOffset2 = gmtOffset.replace(':', '');
            
            //if(zonedDate == 'GMTZ') zonedDate = 'GMT+00:00';
            hashedTimezone = hashedTimezones[gmtOffset2];
            if(!hashedTimezone) hashedTimezone = hashedTimezones[gmtOffset2] = [];
            hashedTimezone.push(item);
            
            timeZoneHtml += formatString(
                '<option value="{0}"{1}>{0} ({2})</option>',
                item, item == defaultTimeZone ? ' selected' : '',
                gmtOffset
            );
        }
    });
    
    $timezone.html(timeZoneHtml);
    $timezone = $timezone.first().val(timeZone);
    
    $clonedOutputRow = $('[data-role="output-row"]:last').clone();

    var $flatPickr = $('#txt-date-picker').parent();
    $flatPickr
        .flatpickr({
            wrap: true,
            allowInput: true,
            enableTime: true,
            enableSeconds: true,
            onChange: function(selectedDates, dateStr, instance) {
                var date = selectedDates && selectedDates[0];
                date = isValidDate(date) ? dateFns.format(date, "MM/dd/yyyy h:mm:ss a") : '';

                $input
                    .val(date)
                    .trigger('input');
                // flatPickr.close();
            }
        });
        var flatPickr = $flatPickr[0]._flatpickr;
            
    $timezone
        .select2(select2Options)
        .on('select2:open', function(event) {
            var $target = $(event.target),
                select2 = $target.data('select2'),
                $search = (select2.dropdown.$search || select2.selection.$search).removeAttr('disabled');
                    
            if(parsedGmtOffset) {
                var $results = $search.parent().next().addClass('invisible');
                    
                setTimeout(function() {
                    var value = $target.val();
                    $search
                        .attr('disabled', 'true')
                        .val(parsedGmtOffset)
                        .trigger('input');
                    $results.removeClass('invisible');
                    
                    $target.val(value).trigger('change.select2');
                }, 1);
            }
        });
        
    $('select')
        .filter('[data-role="ddl-timezone"]')
        .select2(select2Options)
        .end()
        .filter('[data-role="ddl-format"]')
        .select2($.extend({}, select2Options, {width: 'calc(100% - 31px)'}));
    
    each(storage.rows, function(item, index) {
        onInitRow(null, item, index);
    });
    
    function onChange(event) {
        var $target = $(event.target),
            $outputRows = $target.closest('[data-role="output-row"]'),
            rows = storage.rows,
            dateString;

        //event was triggered from form
        if(!$outputRows.length) {
            var $outputWrapper = $('#output-wrapper');
                
            if(dateString = $input.val().trim()) {
                parsedDate = dateFns.parse(dateString);
                
                if(!isValidDate(parsedDate)) {
                    parsedDate = null;
                    $outputWrapper
                        .css({
                            opacity: '0.25',
                            pointerEvents: 'none'
                        });
                        
                    $input.add($input.parent()).addClass('is-invalid');
                }
                else {
                    //parsedDate was created with current time zone so convert
                    //parsedDate = dateFns.zonedTimeToUtc(parsedDate, defaultTimeZone);
                    
                    $outputWrapper
                        .removeClass('d-none')
                        .css({
                            opacity: '',
                            pointerEvents: ''
                        });
                        
                    $input.add($input.parent()).removeClass('is-invalid');
                    
                    var matchGmt = /(GMT|UTC)([-+])?(\d{0,2}):?(\d{0,2})?/i;
                
                    timeZone = null;
                    parsedGmtOffset = null;

                    $outputRows = $('[data-role="output-row"]');

                    //$timezone.removeAttr('disabled');
                    
                    var timeDetails = dateFns.parseTimeDetails(dateFns.splitDateString(dateString)),
                        gmtOffset = dateString.match(matchGmt),
                        isTextInput = $target.prop('id') == 'txt-input',
                        origOffset,
                        parsedTimeZone;
                    
                    if(timeDetails.timestamp) {
                        if(timeDetails.parsedOffset != null) {
                            var offset = timeDetails.parsedOffset;
                            gmtOffset = 'GMT' + (offset <= 0 ? '+' : '-') + padLeft(Math.floor(Math.abs(offset / 60)), 2) + padLeft(Math.abs(offset % 60), 2);
                        }
                    }       
                    else if(gmtOffset = dateString.match(matchGmt)) {
                        origOffset = gmtOffset.shift();
                        if(!gmtOffset[1]) gmtOffset[1] = '+';
                        gmtOffset[2] = (gmtOffset[2] || '00').substr(0, 2) + (gmtOffset[3] || '00').substr(0, 2);
                        gmtOffset[3] = '';
                        
                        if(gmtOffset[2] == '0000') {
                            timeZone = 'UTC';
                            //parsedDate was not created with current time zone so convert
                            //parsedDate = dateFns.utcToZonedTime(parsedDate, defaultTimeZone);
                        }
                        gmtOffset = gmtOffset.join('');
                    }
                    
                    if(gmtOffset) {
                        // if(gmtOffset != origOffset) {
                        //     timeZone = defaultTimeZone;
                        // }
                        parsedGmtOffset = gmtOffset;
                    }
                    else if(isTextInput) {
                        //timeZone = defaultTimeZone;
                        //gmtOffset = defaultGmtOffset;
                        if(timeZone != defaultTimeZone) {
                            var selected = $timezone.select2('data')[0];
                            if(selected) {
                                gmtOffset = selected.text.match(matchGmt)[0];
                            }
                        }
                        if(!gmtOffset) gmtOffset = defaultGmtOffset;
                    }

                    if(gmtOffset && (hashedTimezone = hashedTimezones[gmtOffset])) {
                        if(!timeZone) {
                            if(gmtOffset == defaultGmtOffset) parsedTimeZone = defaultTimeZone;
                            else if(gmtOffset == 'GMT+0000') parsedTimeZone = 'UTC';
                            else {
                                parsedTimeZone = find(hashedTimezone, function(item) {
                                    return item.indexOf(defaultCountry) >= 0;
                                });
                                if(!parsedTimeZone) parsedTimeZone = hashedTimezone[0];
                            }
                            
                            if(parsedTimeZone && parsedTimeZone != timeZone) {
                                timeZone = parsedTimeZone;
                            }
                        }
                                
                        if(timeZone && isTextInput) {
                            $timezone
                                .val(timeZone)
                                .trigger('change');
                        }
                        
                        if(gmtOffset != defaultGmtOffset) {
                            var selected = $timezone.select2('data')[0];
                            if(selected) {
                                parsedGmtOffset = selected.text.match(matchGmt)[0];
                            }
                        }
                    }
                    
                    $timezone
                        .attr('disabled', !!parsedGmtOffset)
                        .siblings('.invalid-feedback').toggleClass('d-block', !!parsedGmtOffset);
                    
                    if(!timeZone) timeZone = $timezone.val();
                }
            }
            else {
                parsedDate = null;
                parsedGmtOffset = null;
                
                $outputWrapper
                    .css({
                        opacity: '0.25',
                        pointerEvents: 'none'
                    });
                    
                $timezone
                    .attr('disabled', false)
                    .siblings('.invalid-feedback').removeClass('d-block');
            }
        }
        
        // var utcDateFormatted;
        if(isValidDate(parsedDate)) {
            var rows = storage.rows,
                utcDate = timeZone == 'UTC' ? parsedDate : dateFns.zonedTimeToUtc(parsedDate, timeZone),
                dateFormatted;
            //var utcDate2 = dateFns.zonedTimeToUtc(parsedDate, defaultTimeZone);
            //var utcDate = dateFns.utcToZonedTime(parsedDate, timeZone),
            
            // utcDateFormatted = dateFns.format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss'.'SSS'Z'", {
            //     timeZone: 'UTC'
            // })
            // .replace("'", '');
            //utcDateFormatted = dateFns.format(dateFns.utcToZonedTime(parsedDate, 'UTC'), "yyyy-MM-dd'T'HH:mm:ss'.'SSS'Z'", {
            //    timeZone: 'UTC'
            //})
            //.replace("'", '');
            
            $outputRows.each(function() {
                var $this = $(this),
                    $ddlTimeZone = $this.find('[data-role="ddl-timezone"]'),
                    selectedTimeZone = $ddlTimeZone.val(),
                    //zonedDate = dateFns.utcToZonedTime(parsedDate, selectedTimeZone),
                    zonedDate = dateFns.utcToZonedTime(utcDate, selectedTimeZone),
                    format = $this.find('[data-role="ddl-format"]').val(),
                    index = $this.index(),
                    row = rows[index];
                
                    if(!row) row = rows[index] = {};
                
                //handle RangeError: Expected Area/Location(/Location)* for time zone
                if($ddlTimeZone.select2('data')[0].text.indexOf('GMT+00:00') >= 0) {
                    selectedTimeZone = 'UTC';
                }
                
                //date-fns-tz appears to have a format bug when escaping characters before xx, ex. 'GMT'xx
                dateFormatted = dateFns.format(zonedDate, format, {
                        timeZone: selectedTimeZone
                    })
                    .replace("'", '');
                
                // if(dateFormatted != oldDateFormatted) console.warn('old', oldDateFormatted, '\nnew', dateFormatted);
                    
                //console.log(parsedDate, zonedDate);
                //Sun Nov 29 2020 13:38:57 GMT-0500 (Eastern Standard Time)
                //2020-11-29T19:37:06.307Z
                
                $this.find('[data-role="txt-date"]').val(dateFormatted);
                
                row.date = dateFormatted;
                row.timezone = selectedTimeZone;
                row.format = format;
            });
        }
        
        if(dateString != null) storage.date = dateString;
        storage.timezone = timeZone;
        
        try {
                localStorage.setItem(storageKey, JSON.stringify(storage));
        }
        catch(exc){}
    }
    
    function onInitRow(event, row, index) {
        if(event) event.preventDefault();

        var $btnAddRow = $('#btn-add-row'),
            $outputRow;
            
        if(!row || index) {
            $outputRow = $clonedOutputRow
                .clone()
                .insertBefore($btnAddRow);
        }
        else {
            $outputRow = $btnAddRow.prev();
        }
        
        var $prevOutputRow = $outputRow.prev();
            
        $outputRow.find('[data-action="remove-row"]')
            .removeAttr('disabled');
            
        $outputRow
            .find('select')
            .filter('[data-role="ddl-timezone"]')
            .select2(select2Options)
            .end()
            .filter('[data-role="ddl-format"]')
            .select2($.extend({}, select2Options, {width: 'calc(100% - 31px)'}));
            
        $outputRow
            .find('input,select')
            .each(function() {
                var $this = $(this),
                    value;
                if(row) {
                    value = row[$this.attr('data-role').split('-')[1]];
                }
                else {
                    value = $prevOutputRow.find(formatString('[data-role="{0}"]', $this.attr('data-role'))).val();
                }
                $this.val(value);
                if(this.nodeName.toLowerCase() == 'select') $this.trigger('change');
            });
            
        if(!row) {
            var index = $outputRow.index();
            storage.rows[index] = $.extend(true, {}, storage.rows[index - 1]);
            try {
                localStorage.setItem(storageKey, JSON.stringify(storage));
            }
            catch(exc){}
        }
        
        if($('#output-wrapper').find('[data-role="output-row"]').length >= 6) {
            $btnAddRow.attr('disabled', true);
        }
    }
    
    $(document.body)
        .on('submit', '#form-parse', function(event) {
            event.preventDefault();
            //onChange();
        })
        .on('click', '#btn-calendar', function(event) {
            flatPickr.setDate(parsedDate || new Date(), false);
        })
        .on('input', '#txt-input, select', onChange)
        .on('focus', '#txt-input', function(event) {
            flatPickr.close();
        })
        .on('focus', '[data-role="txt-date"]', function(event) {
            var target = event.target,
                isCopied;
                
            try {
                target.select(); 
                target.setSelectionRange(0, 99999); /*For mobile devices*/
                document.execCommand('copy');
                isCopied = true;
            }
            catch(exc){
                console.warn(exc);
            }
            
            target.value = target.value;
                
            if(isCopied) {
                var $target = $(event.target)
                    .tooltip({
                        title: 'Copied',
                        trigger: 'manual'
                    })
                    .tooltip('show')
                    .on('hidden.bs.tooltip', function() {
                        $target.tooltip('dispose');
                    });
                    
                setTimeout(function() {
                    $target.tooltip('hide');
                }, 700);
            }
        })
        .on('click', '[data-action="add-row"]', onInitRow)
        .on('click', '[data-action="remove-row"],[data-action="clear-rows"]', function(event) {
            event.preventDefault();
            var $this = $(this);
            if($this.attr('data-action') == 'clear-rows') {
                $('#output-wrapper')
                    .find('[data-role="output-row"]')
                    .each(function(index) {
                        if(index) $(this).remove();
                    });
                    
                storage.rows.length = 0;
            }
            else {
                var $row = $this.closest('[data-role="output-row"]');
                storage.rows.splice($row.index(), 1);
                $row.remove();
            }
            
            try {
                localStorage.setItem(storageKey, JSON.stringify(storage));
            }
            catch(exc){}

            if($('#output-wrapper').find('[data-role="output-row"]').length < 6) {
                $('#btn-add-row').removeAttr('disabled');
            }
        });
        
    $input.trigger('input');
});

if(location.href.indexOf('//localhost') >= 0) {
    window.dateFns = dateFns;
}
